import { getPostBySlug, getRelatedPostsByTags } from '$lib/posts';
import type { Load } from '@sveltejs/kit';

export const load: Load = ({ params: { slug } }) => {
	const post = getPostBySlug(slug!);

	return {
		posts: getRelatedPostsByTags(post.metadata.tags, 5),
		page: post.default
	};
};
